import { getUniqueId } from "./unique-id";

describe("getUniqueId", () => {
    it("generates a different id each time", () => {
        const id1 = getUniqueId();
        const id2 = getUniqueId();
        expect(id1 === id2).toBeFalsy();
    });
});
